export default __webpack_public_path__ + "static/media/sunderland.a431ca68.png";